import ProvidedResourcesContainer from './ProvidedResources.container';
export default ProvidedResourcesContainer;
